export default {
    title: 'BALLPARK Xmas YOKOHAMA KANNAI 2025',
    titleTemplate: '',
    description: '今年で6年目の「ボールパークファンタジア」。今年はクリスマスマーケットに進化します。2025年11月21日から計35日間、関内駅から徒歩3分の横浜公園を中心に、イルミネーションやアクティビティコンテンツなどをお楽しみいただける「BALLPARK Xmas YOKOHAMA KANNAI 2025」を開催します。',
    url: {
        dev: 'https://dev.ballparkfantasia.com',
        prod: 'https://ballparkfantasia.com'
    },
    locale: 'ja_JP',
    site_name: 'BALLPARK Xmas YOKOHAMA KANNAI 2025',
    version: '1.0',
    app_name: 'BPF',
    sns: {
        twitter: 'https://twitter.com/bp_fantasia/',
        // instagram: 'https://www.instagram.com/ballpark_fantasia/'
        instagram: 'https://www.instagram.com/ballpark_xmas/'
    },
    shareUrl: 'https://ballparkfantasia.com',
    cdnImage: {
        ctf: 'images.ctfassets.net',
        dev: 'images.ctfassets.net',
        prod: 'ballparkfantasia.cdn-dena.com'
    }
};
